import React, { useEffect, useState } from 'react';

import SendInvite from '../../components/sendInvite/SendInvite';
import User from '../../models/User';
import useBlocRef from '../../utils/useBlocRef.hook';

const inviteFields = [
  { label: 'Creator Name', name: 'name', placeholder: 'Creator Name', required: true, type: 'text' },
  { label: 'Telephone', name: 'phoneNumber', placeholder: '+27828501512', required: true, type: 'phone' },
  { label: 'Creator Email Address', name: 'email', placeholder: 'email@address.com', required: true, type: 'text' },
];

export default () => {
  const blocRef = useBlocRef('resendInviteBloc');
  const [creator, setCreator] = useState(new User());

  useEffect(() => {
    const sub = blocRef.current.creatorToInvite$.subscribe(setCreator);
    return () => sub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onInvite = async ({ name, phoneNumber, email }) => {
    await blocRef.current.resendInvite(name, phoneNumber, email, creator.id);
  };

  return (
    <SendInvite
      fields={inviteFields}
      buttonText="Resend Invite"
      onInvite={onInvite}
      user={creator}
      title="Resend Invite"
      hint="If a user has not accepted or accessed their account you can resend the invite from this screen."
      note="Note that an invitation link will be sent to the creator email address once submitted."
      isSubmitting$={blocRef.current.isResendingInvite$}
    />
  );
};
